import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = '' }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group block cursor-pointer ${className}`}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面`}
          title={`${movie.title} 高清影视在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded bg-primary-950/75 text-[11px] font-medium text-accent-400 backdrop-blur-sm">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded bg-accent-500/90 text-[11px] font-medium text-background-50">
          {movie.type}
        </span>
      </div>
      <h3 className="mt-2.5 text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {movie.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
        {movie.year} · {movie.region}
      </p>
    </Link>
  );
}